<template>
  <div class="flex flex-col lg:flex-row lg:gap-1">
    <div class="flex-1">
      <p class="font-semibold lg:text-20 mb-0.5 lg:mb-1">
        <template v-if="providersCount === 1">
          {{ $t('transfer_comparison.one_provider_found') }}
        </template>
        <template v-else>
          {{ $t('transfer_comparison.compare_providers', { count: providersCount }) }}
        </template>
      </p>
      <p v-if="providersCount > 1" class="text-12 lg:text-18">
        {{ $t('transfer_comparison.sorted_by_amount') }}
      </p>
      <AffiliateDisclosure v-if="IS_MOBILE_APP" />
      <div class="hidden lg:flex items-center mt-1">
        <AffiliateDisclosure />
        <ReportProblem
          class="hidden lg:inline-block border-l border-gray-700 ml-2 pl-2"
          :current-tab="currentTab"
        />
      </div>
    </div>
    <div v-if="showMmrWidget" class="mt-2 lg:mt-0 md:flex gap-4">
      <MidMarketRateWidget
        :mid-market-rate="results.midMarket.rate"
        :comparison-id="results.comparisonId"
        :current-tab="currentTab"
        :currency-from-iso="corridor.currencyFrom.iso"
        :currency-to-iso="corridor.currencyTo.iso"
        class="hidden md:flex flex-1 pt-2 md:pb-2 md:px-3"
      />
      <SubscribeButton
        v-if="!IS_MOBILE_APP"
        :button-class="[
          hasSpotlight || tabsLength > 1 ? 'block' : 'hidden',
          'md:block bg-white rounded-6 font-semibold drop-shadow-1 hover:drop-shadow-3 truncate p-3 w-full h-full lg:w-auto',
        ]"
        :comparison-id="results.comparisonId"
        :current-tab="currentTab"
        creation-location="imt_results_top_button"
        flex-layout
      />
    </div>
    <div v-if="!showMmrWidget && !IS_MOBILE_APP" class="flex mt-2 lg:mt-0">
      <SubscribeButton
        class="w-full"
        button-class="truncate btn btn-outline p-3 bg-white text-16 lg:text-18 w-full lg:w-auto"
        :comparison-id="results.comparisonId"
        :current-tab="currentTab"
        creation-location="imt_results_top_button"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import SubscribeButton from './subscribe-button.vue'
import MidMarketRateWidget from './mid-market-rate-widget/mid-market-rate-widget.vue'
import AffiliateDisclosure from './affiliate-disclosure.vue'
import ReportProblem from './report-problem.vue'
import type { GQLTransferComparison } from './generated/transfer-comparison'
import type { PaymentType, Corridor } from '@core/types/imt'

const IS_MOBILE_APP = __IS_MOBILE_APP__

const props = defineProps<{
  providersCount: number
  currentTab: PaymentType
  landingMode: boolean
  results: GQLTransferComparison['results']
  tabsLength: number
  hasSpotlight: boolean
  showMmrWidget?: boolean
}>()

const corridor = inject('corridor') as Corridor

const showMmrWidget = computed(() => {
  return (
    !props.landingMode &&
    corridor.currencyFrom !== corridor.currencyTo &&
    props.results.providerQuotes.length > 0
  )
})
</script>
